import { useEffect, useRef, useState } from "react";
import {
  getPolicyActivityListByTransaction,
  mapActivityDtoToEntry,
} from "utils/api/policyActivityApi";
import { PolicyActivityEntry } from "entities/UIModel/PolicyManagementRecord";
import { useProfileSettingsCache } from "utils/context/ProfileSettingsContext";

// Loads a transaction's activity/history entries from the backend (read-only).
export function usePolicyActivity(policyTransactionId: number | undefined) {
  const [{ profileSettings }] = useProfileSettingsCache();
  const userTimeZone = profileSettings?.userTimeZone ?? "";
  const [activity, setActivity] = useState<PolicyActivityEntry[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const reqIdRef = useRef(0);

  useEffect(() => {
    if (!policyTransactionId || !userTimeZone) return;
    const myReq = ++reqIdRef.current;
    setIsLoading(true);
    getPolicyActivityListByTransaction({
      PolicyTransactionID: policyTransactionId,
      UserTimeZone: userTimeZone,
    })
      .then((dtos) => {
        if (reqIdRef.current !== myReq) return;
        setActivity(dtos.map(mapActivityDtoToEntry));
        setIsLoading(false);
      })
      .catch(() => {
        if (reqIdRef.current === myReq) setIsLoading(false);
      });
  }, [policyTransactionId, userTimeZone]);

  return { activity, isLoading };
}

export default usePolicyActivity;
